import { FC } from 'react';

import { Box, styled } from '@mui/material';

import {
  CALENDAR_PANEL_BASE_STYLES,
  CALENDAR_SCROLL_CONTENT_SPACING,
} from '../../shared/Calendar.layout';

export const DayViewGrid = styled(Box)(() => ({
  ...CALENDAR_PANEL_BASE_STYLES,
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
}));

export const DayViewInnerFrame = styled(Box)(() => ({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  minHeight: 0,
  flexDirection: 'column',
  alignItems: 'stretch',
}));

export const DayViewScrollArea = styled(Box)(() => ({
  position: 'relative',
  flex: '1 1 0',
  minHeight: 0,
  overflow: 'hidden',
}));

export const DayViewScroller = styled(Box)(() => ({
  position: 'absolute',
  inset: 0,
  ...CALENDAR_SCROLL_CONTENT_SPACING,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const DayViewSectionsFrame = styled(Box)(() => ({
  display: 'flex',
  flex: '1 0 auto',
  width: '100%',
  minHeight: '100%',
  flexDirection: 'row',
  alignItems: 'stretch',
}));

export const SeverityColumn = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '10px',
  flex: '1',
  minWidth: 0,
  padding: '8px 8px',
}));

export const VerticalDivider: FC = () => (
  <Box
    sx={{
      width: '1px',
      alignSelf: 'stretch',
      background: '#EBEBEE',
    }}
  />
);
